import { useCallback } from "react";

import { useToast } from "../../../../components";
import { useRegenerateAiInterviewEvaluationMutation } from "../../../graphql";

interface UseRegenerateEvaluationReturn {
  regenerateEvaluation: (callId: string) => void;
  isRegenerating: boolean;
}

export const useRegenerateEvaluation = (): UseRegenerateEvaluationReturn => {
  const toast = useToast();

  const [regenerateMutation, { loading: isRegenerating }] =
    useRegenerateAiInterviewEvaluationMutation({
      onCompleted: () => {
        toast({
          title: "Evaluation regeneration started",
          description:
            "The evaluation is being regenerated. Please refresh the page in ~60s to see the updated evaluation.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      },
      onError: (apolloError) => {
        toast({
          title: "Error regenerating evaluation",
          description:
            apolloError.message ||
            "An unexpected error occurred. Please try again.",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      },
    });

  const regenerateEvaluation = useCallback(
    (callId: string) => {
      if (!callId) {
        return;
      }
      regenerateMutation({
        variables: { callId },
      });
    },
    [regenerateMutation]
  );

  return {
    regenerateEvaluation,
    isRegenerating,
  };
};
